import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import ClearFormButtonHtmlRenderer from './Renderer/ClearFormButtonHtmlRenderer';
const ClearFormButtonControls = lazyLoad(() => import('./Controls/ClearFormButtonControls'));
export default (settings) => {
    const plugin = createPlugin(Object.assign({ Controls: ClearFormButtonControls, Renderer: ClearFormButtonHtmlRenderer }, settings));
    return plugin;
};
//# sourceMappingURL=index.js.map